import React from 'react';
import FaBan from 'react-icons/lib/fa/ban';
import { defaultConfig } from '../services/API';

const ScreenerOnlyIcon = require('../images/icons/screener_only_updated.png');
const UniversalIcon = require('../images/icons/universal_updated.png');
const ORFOnlyIcon = require('../images/icons/orf_only_updated.png');
const numbersRanIcon = require('../images/icons/number_ran_icon.png');
const colorsRanIcon = require('../images/icons/color_ran_icon.png');
const shapesRanIcon = require('../images/icons/shape_ran_icon.png');
const ComprehensionIcon = require('../images/icons/Comprehension.png');
const DecodingIcon = require('../images/icons/Decoding.png');
const DyslexiaScreenerIcon = require('../images/icons/DyslexiaScreener.png');
const SightIcon = require('../images/icons/Sight.png');
const PhonAwareIcon = require('../images/icons/PhonAware.png');

const ASSESSMENT_TASK = {
  RAN: 'RAN',
  WORD_MANIPULATION: "Word Manipulation",
  NONSENSE_WORD_REPETITION: "Nonsense Word Repetition",
  LETTER_SOUNDS: 'Letter Sounds',
  WORD_READING: 'Word Reading',
  BLENDING: 'Blending',
  NWF: 'NWF',
  SPELLING: 'Spelling',
  VOCABULARY: 'Vocabulary',
  LISTENING_COMPREHENSION: 'Listening Comprehension',
  ORAL_READING_FLUENCY: 'Oral Reading Fluency',
  READING_COMPREHENSION: 'Reading Comprehension',
  LETTER_NAMING_AND_SOUNDS: 'Letter Naming And Sounds',
};

const DYSLEXIA_TASKS = [
  { name: "RAN", value: "ran" },
  { name: "Word Manipulation", value: "wordManipulation" },
  { name: "Nonsense Word Repetition", value: "nonsenseWordReplication" },
  { name: "Letter Sounds", value: "letterSounds" },
  { name: "Word Reading", value: "wordReading" },
  { name: "Blending", value: "blending" }
];

export const READING_ROPE_DOMAIN = {
  DYSLEXIA_RISK: {
    name: 'Dyslexia Risk',
    icon: DyslexiaScreenerIcon,
  },
  DECODING: {
    name: 'Decoding',
    icon: DecodingIcon,
  },
  PHONEMIC_AWARENESS: {
    name: 'Phonemic Awareness',
    icon: PhonAwareIcon,
  },
  COMPREHENSION: {
    name: 'Comprehension',
    icon: ComprehensionIcon,
  },
  SIGHT_RECOGNITION: {
    name: 'High Frequency Words',
    icon: SightIcon,
  },
};

// Default assessment data
const CONFIGURATION_DATA = [
  {
    name: ASSESSMENT_TASK.RAN,
    description: 'Rapid automized naming requires the student to identify and articulate the elements of a long list. Processing speed and accuracy are measured.',
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DYSLEXIA_RISK
    ],
    configuration: [
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
    ]
  },
  {
    name: ASSESSMENT_TASK.WORD_MANIPULATION,
    description: 'Students are verbally given a two-syllable word (e.g. \"baseball\") and asked to respond with one of the syllables removed. The entire activity is conducted orally without written words or images.',
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DYSLEXIA_RISK,
      READING_ROPE_DOMAIN.PHONEMIC_AWARENESS
    ],
    configuration: [
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
    ]
  },
  {
    name: ASSESSMENT_TASK.NONSENSE_WORD_REPETITION,
    description: 'Students are asked to repeat a nonsense word with two or more syllables. Students must listen to the word, retain the word, and then repeat all the parts of the word as they\'ve retained them.',
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DYSLEXIA_RISK,
      READING_ROPE_DOMAIN.PHONEMIC_AWARENESS
    ],
    configuration: [
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
    ]
  },
  {
    name: ASSESSMENT_TASK.LETTER_SOUNDS,
    description: 'The student is shown a letter and asked to make the associated sound.  For vowels, several alternatives are accepted.',
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DYSLEXIA_RISK,
      READING_ROPE_DOMAIN.DECODING
    ],
    configuration: [
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
    ]
  },
  {
    name: ASSESSMENT_TASK.WORD_READING,
    description: 'The student is shown the text of words, one at a time.  The student must read the word.',
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DYSLEXIA_RISK,
      READING_ROPE_DOMAIN.DECODING
    ],
    configuration: [
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
    ]
  },
  {
    name: ASSESSMENT_TASK.BLENDING,
    description: 'A video is provided of a person slowly articulating each phoneme in a word.  The students must blend the sound into the complete word accurately.',
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DYSLEXIA_RISK,
      READING_ROPE_DOMAIN.PHONEMIC_AWARENESS
    ],
    configuration: [
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
      { value: false, ui: <FaBan size="30" color="#ccc" /> },
    ]
  },
  {
    name: ASSESSMENT_TASK.NWF,
    description: "This task requires the student to read non-words in order to assess decoding skills.",
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DYSLEXIA_RISK,
      READING_ROPE_DOMAIN.DECODING
    ],
    configuration: defaultConfig.NWF_CONFIG,
    licenseTableName: "nwfConfig",
  },
  {
    name: ASSESSMENT_TASK.SPELLING,
    description: "Student ability to spell and encode will be tested with this task.",
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DYSLEXIA_RISK,
      READING_ROPE_DOMAIN.DECODING
    ],
    configuration: defaultConfig.SPELLING_CONFIG,
    licenseTableName: "spellingConfig",
  },
  {
    name: ASSESSMENT_TASK.VOCABULARY,
    description: " This task consists of choosing a descriptor or picture that best matches the definition of a word.",
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DYSLEXIA_RISK,
      READING_ROPE_DOMAIN.COMPREHENSION
    ],
    configuration: defaultConfig.VOCABULARY_SCREENER_CONFIG,
    licenseTableName: "vocabularyScreenerConfig",
  },
  {
    name: ASSESSMENT_TASK.LISTENING_COMPREHENSION,
    description: "Students will answer questions about a story they've heard in order to gauge their listening comprehension skills.",
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DYSLEXIA_RISK,
      READING_ROPE_DOMAIN.COMPREHENSION
    ],
    configuration: defaultConfig.LISTENING_COMP_CONFIG,
    licenseTableName: "listeningCompConfig"
  },
  {
    name: ASSESSMENT_TASK.ORAL_READING_FLUENCY,
    description: "This task consists of reading a passage to ascertain overall fluency and other threads of mastery.  The passage will be dynamically adapted to better guage student ability.",
    reading_rope_domain: [
      READING_ROPE_DOMAIN.DECODING,
      READING_ROPE_DOMAIN.PHONEMIC_AWARENESS,
      READING_ROPE_DOMAIN.SIGHT_RECOGNITION,
      READING_ROPE_DOMAIN.COMPREHENSION
    ],
    configuration: [
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
      { value: true, ui: 'Required' },
    ]
  },
  {
    name: ASSESSMENT_TASK.READING_COMPREHENSION,
    description: "Students will answer questions about the passage they've read to gauge their comprehension skills.",
    reading_rope_domain: [
      READING_ROPE_DOMAIN.COMPREHENSION
    ],
    configuration: defaultConfig.READING_COMP_CONFIG,
    licenseTableName: "readingCompConfig",
  }
];

// Filter options
const ASSESSMENT_MODE_OPTIONS = [
  {
    name: 'UNIVERSAL SCREENER',
    icon: UniversalIcon,
    description: 'Students complete a series of short reading tasks followed by an Oral Reading Fluency passage.',
    filter: [
      ASSESSMENT_TASK.RAN,
      ASSESSMENT_TASK.WORD_MANIPULATION,
      ASSESSMENT_TASK.NONSENSE_WORD_REPETITION,
      ASSESSMENT_TASK.LETTER_SOUNDS,
      ASSESSMENT_TASK.WORD_READING,
      ASSESSMENT_TASK.BLENDING,
      ASSESSMENT_TASK.NWF,
      ASSESSMENT_TASK.SPELLING,
      ASSESSMENT_TASK.VOCABULARY,
      ASSESSMENT_TASK.LISTENING_COMPREHENSION,
      ASSESSMENT_TASK.ORAL_READING_FLUENCY,
      ASSESSMENT_TASK.READING_COMPREHENSION,
      ASSESSMENT_TASK.LETTER_NAMING_AND_SOUNDS,
    ],
    assessmentEnabled: true,
    screenerEnabled: true
  },
  {
    name: 'ORF ONLY',
    icon: ORFOnlyIcon,
    description: 'Students read an Oral Reading Fluency passage aloud.',
    filter: [
      ASSESSMENT_TASK.ORAL_READING_FLUENCY,
    ],
    assessmentEnabled: true,
    screenerEnabled: false
  },
  {
    name: 'DYSLEXIA SCREENER ONLY',
    icon: ScreenerOnlyIcon,
    description: 'Students complete a series of short reading tasks. No Oral Reading Fluency passage will be administered.',
    filter: [
      ASSESSMENT_TASK.RAN,
      ASSESSMENT_TASK.WORD_MANIPULATION,
      ASSESSMENT_TASK.NONSENSE_WORD_REPETITION,
      ASSESSMENT_TASK.LETTER_SOUNDS,
      ASSESSMENT_TASK.WORD_READING,
      ASSESSMENT_TASK.BLENDING,
      ASSESSMENT_TASK.NWF,
      ASSESSMENT_TASK.SPELLING,
      ASSESSMENT_TASK.VOCABULARY,
      ASSESSMENT_TASK.LISTENING_COMPREHENSION,
    ],
    assessmentEnabled: false,
    screenerEnabled: true
  }
];

const RAN_OPTIONS = [
  {
    name: 'Number RAN',
    icon: numbersRanIcon,
    description: 'Students read a series of numbers',
    licenseTableForms: [null, null, null, null, null, null, null],
    tag: 'NUMBER_RAN'
  },
  {
    name: 'Color RAN',
    icon: colorsRanIcon,
    description: 'Students read a series of colors',
    licenseTableForms: ['45a64e20-19a1-11ee-81fb-cf2b4b2a7ed5', 'a260e700-19a2-11ee-81fb-cf2b4b2a7ed5', null, null, null, null, null],
    tag: 'COLOR_RAN'
  },
  {
    name: 'Shape RAN',
    icon: shapesRanIcon,
    description: 'Students read a series of shape names',
    licenseTableForms: ['c75883c0-19a1-11ee-81fb-cf2b4b2a7ed5', '8234f890-19a2-11ee-81fb-cf2b4b2a7ed5', null, null, null, null, null],
    tag: 'SHAPE_RAN'
  }
]

const RAN_LABELS = {
  NUMBER_RAN: 'Number RAN',
  COLOR_RAN: 'Color RAN',
  SHAPE_RAN: 'Shape RAN'
}

const SPANISH_MAPPING = {
  BOTH_ONE_SESSION: {test: 1, sequence: ['esp','eng'], licenseTableName: "BOTH_ONE_SESSION"},
  BOTH_TWO_SESSIONS: {test: 2, sequence: ['esp','eng'], licenseTableName: "BOTH_TWO_SESSIONS"},
  BOTH_ONE_SESSION_ENGLISH_FIRST: {test: 1, sequence: ['eng','esp'], licenseTableName: "BOTH_ONE_SESSION_ENGLISH_FIRST"},
  BOTH_TWO_SESSIONS_ENGLISH_FIRST: {test: 2, sequence: ['eng','esp'], licenseTableName: "BOTH_TWO_SESSIONS_ENGLISH_FIRST"},
  ENGLISH_ONLY: {test: 1, sequence: ['eng'], licenseTableName: "ENGLISH_ONLY"},
  SPANISH_ONLY: {test: 1, sequence: ['esp'], licenseTableName: "SPANISH_ONLY"},
};

export {
  ASSESSMENT_TASK,
  DYSLEXIA_TASKS,
  ASSESSMENT_MODE_OPTIONS,
  CONFIGURATION_DATA,
  SPANISH_MAPPING,
  RAN_OPTIONS,
  RAN_LABELS
};